import { connect } from 'react-redux';

import MonthlyInstallmentUI from './MonthlyInstallmentUI';


const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

const MonthlyInstallment = connect(
    mapStateToProps,
    mapDispatchToProps
)(MonthlyInstallmentUI);

export default MonthlyInstallment;
